import { BankAccountSchema, ZodCreateBankAccountSchema, ZodUpdateBankAccountSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type BankAccount = BankAccountSchema;

export const getBankAccounts = async (organizationOrClientId: string): Promise<BankAccount[]> => {
  const response = await apiClient.get<{ bankAccounts: BankAccount[] }>(`/api/bank-account/${organizationOrClientId}`);
  return response.data.bankAccounts;
};

export const createBankAccount = async (bankAccountData: ZodCreateBankAccountSchema): Promise<BankAccount> => {
  const response = await apiClient.post<{ bankAccount: BankAccount }>("/api/bank-account", bankAccountData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.bankAccount;
};

export const updateBankAccount = async (bankAccountData: ZodUpdateBankAccountSchema): Promise<BankAccount> => {
  const response = await apiClient.put<{ bankAccount: BankAccount }>(
    `/api/bank-account/${bankAccountData.id}`,
    bankAccountData,
    {
      headers: { "Content-Type": "application/json" },
    },
  );
  return response.data.bankAccount;
};

export const deleteBankAccount = async (
  bankAccountId: string,
): Promise<{ message: string; bankAccount: BankAccount }> => {
  const response = await apiClient.delete<{ message: string; bankAccount: BankAccount }>(
    `/api/bank-account/${bankAccountId}`,
  );
  return response.data;
};

export default getBankAccounts;
